import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  // BrowserRouter as Router,
  HashRouter
} from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  gtmId: 'GTM-KTFT2VL'
}

TagManager.initialize(tagManagerArgs)

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HashRouter>

    <App />
    <Toaster />
  </HashRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
